import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import { initAnalytics } from '@/utilities/analytics';

import Navbar from '@/components/Navbar.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const scripts = ['https://kit.fontawesome.com/02faa02085.js'];

// For private analytics
initAnalytics('G-8X0SZPBPXE');

// TODO: Would rather not directly touch the DOM
scripts.forEach((script) => {
  const tag = document.createElement('script');
  tag.setAttribute('src', script);
  document.head.appendChild(tag);
});

store.commit('setNew', true);
store.commit('setReady');

const updateTheme = (isDark: boolean) => {
  if (isDark) {
    document.body.classList.add('dark-mode');
  }
  else {
    document.body.classList.remove('dark-mode');
  }
};

watch(() => store.state.dark, updateTheme);
onMounted(() => {
  const mql = window.matchMedia('(prefers-color-scheme: dark)');

  store.commit('syncWithSystem', mql.matches);
  updateTheme(store.state.dark);

  mql.addEventListener('change', (event) => {
    store.commit('syncWithSystem', event.matches);
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar),
    _createVNode(_component_router_view)
  ], 64))
}
}

})